import axios from 'axios';
import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react';
import SelectUser from './SelectUser';

function GroupChatbar(props) {
    const [groupName, setGroupName] = useState("");
    const [imagePreview, setImagePreview] = useState(null)
    const [image, setImage] = useState(null);
    const [users, setUsers] = useState([]);
    const [cards, setCards] = useState([])
 
    useEffect(() => {
        if(props.mymail!==null){
            setUsers([props.mymail])
        }
    }, [props.mymail])
    
    useEffect(() => {
        if(props.userCards){
            setCards(props.userCards)
        }
    }, [props.userCards])
    // .sort(function(a,b) {return (a.firstname > b.firstname) ? 1 : ((b.firstname > a.firstname) ? -1 : 0);} )

    function handleBack() {
        document.querySelector(".groupChatBar").classList.remove("translateProfile");
    }

    function setImagee(e){
        const file = e.target.files[0];
        setImage(file);
        setImagePreview(URL.createObjectURL(file));
    }

    async function uploadImage(){
        const data = new FormData();
        data.append("file",image);
        data.append("upload_preset","ChatApp");
        data.append("cloud_name","dgz1wimeg");
       try {
        var newurl;
        await axios.post("https://api.cloudinary.com/v1_1/dgz1wimeg/image/upload",data).then(res=>{
           newurl = res.data.url;
        })
        return newurl;
       } catch (error) {
        // console.log(error);
       }
    }
 
    async function handleClick(){
        if(groupName===""){
            alert("Fill Group name");
            return;
        }
        if(users.length===0){
            alert("Please, select user/users");
            return;
        }
        
        const url = await uploadImage(image);
        
        var roomId = Math.floor(Math.random() * 100000);
        roomId=roomId.toString();
        const group={
            firstname:groupName,
            image:url,
            roomId,
            users
        }
        
        axios.post("https://newchatapp-mn65.onrender.com/group",group).then((res)=>{
            if(res.data){
                
                window.location.reload();
            }
        })
    }
 
    return (
        <div>
            <div className="groupChatBar">
                <div style={{userSelect:"none"}} className="myProtileTop">
                    <i onClick={handleBack} style={{ fontSize: "1.2rem", cursor: "pointer", paddingLeft: "1rem" }} className="fa-solid fa-arrow-left"></i>
                    <p>Group</p>
                </div>
                <div style={{userSelect:"none"}} className="groupChatbarBody">
                <button onClick={handleClick} className='grpbtn'>Submit</button>
                <div className="groupnameImage">
                    <div className="nameimage">
                        <img draggable="false" src={imagePreview || "images/defaultProfile.png"} alt="group_img" />
                        <input onChange={setImagee} className='nameimageinput' type="file" name="" id="" />
                        <p title="Group name" placeholder="Set Group Name" onInput={(e) => {if(e.target.innerHTML.length>21){e.target.innerHTML=groupName; alert("length must be less than 21")}else{ setGroupName(e.target.innerHTML);} }} contentEditable={true} id="groupname"></p>
                    </div>
                </div>
                    { cards.length!==0 && cards.map((userCard)=>{
                        if(!userCard.users){
                            return <SelectUser setUsers={setUsers} image={userCard.image} firstname={userCard.firstname} email={userCard.email} users={users} />
                        }
                        
                    })}
                </div>

            </div>
        </div>
    )
}

export default GroupChatbar